export class AutonomyInvalidity {
  dt?: string;
  invalidity_id?: number;
  firstname?: string;
  patient_id?: number;
  description?: string;
  version_id?: number;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
